import { render, staticRenderFns } from "./RssCard.vue?vue&type=template&id=10796316&scoped=true&"
import script from "./RssCard.vue?vue&type=script&lang=js&"
export * from "./RssCard.vue?vue&type=script&lang=js&"
import style0 from "./RssCard.vue?vue&type=style&index=0&id=10796316&lang=scss&scoped=true&"
import style1 from "./RssCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10796316",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VCardTitle,VContainer,VFlex,VImg})
